import React from 'react';
import useToken from '../hooks/useToken';
import useUser from '../hooks/useUser';
import { useState, useEffect } from 'react';
import { SERVER_API_URL } from '../config/Constants'
import UserService from "../services/UserService";
import Loading from '../components/Loading'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserSecret, faPenToSquare, faClock, faPlay } from '@fortawesome/free-solid-svg-icons'
import AccountModal from '../components/AccountModal';
import fetchClient from "../utils/http-common";
import GameHistory from '../components/GameHistory';
import { registerAnonymousUser } from '../containers/Login'
import GameUtils from '../utils/gameUtils';

import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  //Image,
  Platform,
  Alert,
  FlatList,
  ActivityIndicator,
  Dimensions
} from 'react-native';
import { useRouteLoaderData, useNavigate } from 'react-router-dom';



export default function Profile() {

  const [ loading, setLoading ] = useState(false);
  const [ showLogin, setShowLogin ] = useState(false);
  const [ data, setData ] = useState('');
  const { user, setUser } = useUser();
  const [showAccount, setShowAccount] = useState(false);
  const [friends, setFriends] = useState([]);
  const [pendingFriendships, setPendingFriendships] = useState([]);
  const [selectedTimes, setSelectedTimes] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const { token, setToken } = useToken();
  const navigate = useNavigate();
  const picWidth = isMobile ? 90 : 180
  const picHeight = isMobile ? 180 : 360
  const getProfile = async (user) => {

    setLoading(true)

    try {
      var res = await UserService.getUser(user.id)
    }
    catch (e) {
      //alert(JSON.stringify(res))
      setShowLogin(true)
      setLoading(false)
      return
      console.log(e)
    }

    try {
      var resFriends = await UserService.getFriends();
      if (resFriends && resFriends.data) {
        setFriends(resFriends.data);
      }
      var resPending = await UserService.getPendingFriends();
      if (resPending && resPending.data) {
        setPendingFriendships(resPending.data);
      }
    } catch (e) {
      console.log(e)
    }

    setLoading(false)
    setData(res.data)
    console.log(res.data)
  }

  useEffect(() => {
    getProfile(user)
  }, []);


  async function updateUser(user) {

    return fetchClient.put(`${SERVER_API_URL}/users/update.json`, user)

   }

  const handleChallenge = async (friendId) => {
    try {
      setLoading(true);
      const res = await GameUtils.createInternalInvitation(friendId, selectedTimes[friendId] || 600);
      setLoading(false);
      if (res && res.data && res.data.id) {
         navigate(`/games/${res.data.id}/invitation`);
      }
    } catch(e) { 
      setLoading(false);
      alert("Error challenging friend");
    }
  }

  const handleAcceptFriend = async (friendId) => {
    try {
      await UserService.acceptFriend(friendId);
      setPendingFriendships(pendingFriendships.filter(f => f.id !== friendId));
      getProfile(user);
    } catch(e) { console.error(e); }
  }

  const handleDenyFriend = async (friendId) => {
    try {
      await UserService.denyFriend(friendId);
      setPendingFriendships(pendingFriendships.filter(f => f.id !== friendId));
    } catch(e) { console.error(e); }
  }

  const renderUserData = (data) => {
    if (!data) data = "N/A"
    if (data.length > 16 && isMobile) data = data.substring(0, 16) + "..."
    return (
      <Text style={{ fontSize: 14, color: "#FFD145", fontWeight: 600, letterSpacing: 2, paddingVertical: 12, textAlign: "left", }}>{data}</Text>
    )
  }

  const renderOneData = (name, data) => {
    return (
      <Row>
      <Col xs={12} md={12}>
      <Text style={{ fontSize: 14, color: "white", paddingVertical: 6,textAlign: "left"}}>{name}: {renderUserData(data)}</Text>
      </Col>
      </Row>
    )
  }


  if (loading) {
    return <Loading />
  }

  if (showLogin) {
    return (<AccountModal
      show={true}
      onHide={() => setShowLogin(false)}
      onPlay={async (user) => {
        setLoading(true)
        var data = await registerAnonymousUser(user)
        setLoading(false)
        if (!data || !data.auth_token) {
          alert('An error occured')
          return
        }
        setShowLogin(false)
        setToken(data.auth_token);
        setUser(data.user)
        navigate('/tuto')
  }
  }/>)
  }


  return (
    <Container style={{
      //flex: 1,
      // flexDirection: isMobile ? "column" : 'row',
       //justifyContent: 'center',
       //alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.2)',
      padding: 24,
      marginTop: 20,
      borderRadius: 12,

   }}>
    {
      user &&
      <AccountModal
      show={showAccount}
      onHide={() => setShowAccount(false)}
      email={user && user.email && !user.email.includes('sumochess.org') ? user.email : undefined}
      username={user.name}
      onSave={async (user) => {
          console.log('Start Game')

          var res = await updateUser(user)
          //alert(JSON.stringify(res.data))
          if (res.data && res.data.user) {
            setUser(res.data.user)
          }
          setShowAccount(false)
          // save new values
        }
  }/>
    }

    <Row className='justify-content-center'>
      <Col xs={8} md={4}>
        <Image
        src={"/imgs/bot_small_tr.png"} fluid
        className=''
        //style={{width: picWidth, height: picHeight}}
         />
      </Col>
      <Col xs={12} md={8}>
      <Row>
      <Col xs={12} md={12}>
        <Text style={{ fontSize: 14, color: "white", paddingVertical: 6,textAlign: "left"}}>name: {renderUserData(data.name)}</Text>
        <Button
          style={{marginLeft: 8}}
          variant="dark"
          size="sm"
          onClick={() => setShowAccount(true)}>
          <FontAwesomeIcon icon={faPenToSquare} />
      </Button>
      </Col>
      </Row>
      {[ "elo",  "win_as_white", "win_as_black", "lost_as_white", "lost_as_black"].map((name) => {
  return renderOneData(name, data[name])
}
)
}
        </Col>
      </Row>

    <Row className='justify-content-center' style={{ position: 'relative', zIndex: 10 }}>
      <Col xs={12} md={8}>
      {pendingFriendships && pendingFriendships.length > 0 && (
        <View style={{ marginTop: 20, width: '100%', marginBottom: 20 }}>
          <Text style={{ fontSize: 18, color: 'white', fontWeight: 'bold', marginBottom: 12 }}>Pending Friend Requests</Text>
          {pendingFriendships.map(friend => (
            <Row key={friend.id} style={{ alignItems: 'center', backgroundColor: '#e2f3f5', padding: 10, borderRadius: 8, marginBottom: 8, marginLeft: 0, marginRight: 0 }}>
              <Col xs={7}>
                 <Text style={{ color: '#333', fontSize: 16, fontWeight: 'bold' }}>{friend.name} ({friend.elo})</Text>
              </Col>
              <Col xs={5} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Button variant="success" size="sm" style={{ marginRight: 8 }} onClick={() => handleAcceptFriend(friend.id)}>Accept</Button>
                <Button variant="danger" size="sm" onClick={() => handleDenyFriend(friend.id)}>Deny</Button>
              </Col>
            </Row>
          ))}
        </View>
      )}
      {user && friends && friends.length > 0 ? (
        <View style={{ marginTop: 20, width: '100%', marginBottom: 20 }}>
          <Text style={{ fontSize: 18, color: 'white', fontWeight: 'bold', marginBottom: 12 }}>My Enemies</Text>
          {friends.map(friend => (
            <Row key={friend.id} style={{ alignItems: 'center', backgroundColor: '#333', padding: 10, borderRadius: 8, marginBottom: 8, marginLeft: 0, marginRight: 0 }}>
              <Col xs={7}>
                 <Text style={{ color: 'white', fontSize: 16 }}>{friend.name} ({friend.elo})</Text>
              </Col>
              <Col xs={5} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                 <Dropdown onSelect={(e) => setSelectedTimes({...selectedTimes, [friend.id]: e})} style={{ marginRight: '8px' }}>
                    <Dropdown.Toggle variant="secondary" size="sm" style={{ padding: '4px 8px', display: 'flex', alignItems: 'center', backgroundColor: '#555', borderColor: '#444' }}>
                       <FontAwesomeIcon icon={faClock} style={{ marginRight: 4 }} />
                       {selectedTimes[friend.id] === "-1" ? "Any" :
                        selectedTimes[friend.id] === "60" ? "1m" :
                        selectedTimes[friend.id] === "180" ? "3m" :
                        selectedTimes[friend.id] === "1800" ? "30m" :
                        selectedTimes[friend.id] === "3600" ? "1h" :
                        selectedTimes[friend.id] === "604800" ? "7d" : "10m"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu variant="dark">
                       <Dropdown.Item eventKey="-1">Any</Dropdown.Item>
                       <Dropdown.Item eventKey="60">1 min</Dropdown.Item>
                       <Dropdown.Item eventKey="180">3 min</Dropdown.Item>
                       <Dropdown.Item eventKey="600">10 min</Dropdown.Item>
                       <Dropdown.Item eventKey="1800">30 min</Dropdown.Item>
                       <Dropdown.Item eventKey="3600">1 h</Dropdown.Item>
                       <Dropdown.Item eventKey="604800">One week</Dropdown.Item>
                    </Dropdown.Menu>
                 </Dropdown>
                 <Button variant="danger" size="sm" onClick={() => handleChallenge(friend.id)}>
                   <FontAwesomeIcon icon={faPlay} />
                 </Button>
              </Col>
            </Row>
          ))}
        </View>
      ) : null}
      </Col>
    </Row>

    <GameHistory/>

  </Container>
  )
}

